var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArtistManagerBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5383 28.6448C29.2181 24.6336 25.6426 21.7573 21.4699 20.3938C25.7123 17.8683 27.7445 12.8195 26.4348 8.0591C25.1251 3.29869 20.7963 0 15.859 0C10.9218 0 6.59295 3.29869 5.28325 8.0591C3.97355 12.8195 6.00577 17.8683 10.2482 20.3938C6.07553 21.7558 2.50002 24.632 0.179821 28.6448C-0.0518168 29.0225 -0.0602283 29.4961 0.157853 29.8818C0.375935 30.2675 0.78615 30.5044 1.2292 30.5006C1.67226 30.4968 2.07835 30.2529 2.28978 29.8635C5.15994 24.9032 10.233 21.9416 15.859 21.9416C21.4851 21.9416 26.5581 24.9032 29.4283 29.8635C29.6397 30.2529 30.0458 30.4968 30.4889 30.5006C30.9319 30.5044 31.3421 30.2675 31.5602 29.8818C31.7783 29.4961 31.7699 29.0225 31.5383 28.6448ZM7.32779 10.9729C7.32779 6.26122 11.1474 2.44164 15.859 2.44164C20.5707 2.44164 24.3903 6.26122 24.3903 10.9729C24.3903 15.6846 20.5707 19.5041 15.859 19.5041C11.1494 19.4991 7.33283 15.6825 7.32779 10.9729Z",
    fill: "#00067E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtistManagerBlue);
export default __webpack_public_path__ + "static/media/artist-manager-blue.eae73a0d8b61e35e96d97531938bf1e9.svg";
export { ForwardRef as ReactComponent };